/**
 * Tag LegalCase
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LegalCaseTagState = {
  legalCaseTag: {
    showDialog: false,
  },
}

export const LegalCaseTagActions = {
  showLegalCaseTagDialog ({ commit }, req) {
    commit('setShowLegalCaseTagDialog', req.value)
  },

  async tagLegalCase ({ commit }, req) {
    return axiosRequest.
      post(`/legal_cases/${req.id}/tags`, {
        tag_ids: req.tagIds,
      }).
      then(({ data }) => {
        commit('setLegalCaseTag', data.tags)
      }).
      catch(handleError)
  },

  async untagLegalCase ({ commit }, req) {
    return axiosRequest.
      delete(`/legal_cases/${req.id}/tags/${req.tagId}`).
      then(({ data }) => {
        commit('setLegalCaseTag', data.tags)
      }).
      catch(handleError)
  },
}

export const LegalCaseTagMutations = {
  setLegalCaseTag: (state, value) => {
    state.legalCase.tags = value
  },
  setShowLegalCaseTagDialog: (state, payload) => {
    state.legalCaseTag.showDialog = payload
  },
}

export const LegalCaseTagGetters = {
  showDialogLegalCaseTag: state => state.legalCaseTag.showDialog,
}
